import * as z from 'zod'

/** The values that are handled within the form context */
export type CreateFolderFormValues = z.infer<typeof CreateFolderSchema>
export const CreateFolderSchema = z.object({
  folderName: z.string().min(1, { message: 'Folder name is required' }),
})
